import { PhaserUtils } from "../utils/PhaserUtils"
import { Sprites } from "../utils/Sprites"

export class Fireworks {
    static FIREWORKS = "fireworks"
    static fireworks: Phaser.Sprite

    static loadFireworks = (game: Phaser.Game) => {
        const load = PhaserUtils.makeLoader(game, "generic")

        load.audio(Fireworks.FIREWORKS, "fireworks.mp3")
        load.atlas(Fireworks.FIREWORKS, "fireworks.json")
    }

    static play = (game: Phaser.Game, x: number, y: number, onComplete?: () => void) => {
        const fireworks = Sprites.add(game, Fireworks.FIREWORKS, {x, y})
        fireworks.animations.add(Fireworks.FIREWORKS, undefined, 10)
        fireworks.bringToTop()
        const fireworksAudio = game.add.audio(Fireworks.FIREWORKS)
        Sprites.playAnimationNTimes(fireworks, Fireworks.FIREWORKS, 2, () => {
            if (onComplete) {
                onComplete()
            }
            fireworksAudio.fadeOut(250)
        })
        fireworksAudio.play()
    }
}
